export enum ExportPlace {
    ActiveEIC = 1,
    AllEIC = 2,
    DeactivatedCodes = 3,
    AllApprovedRequests = 4,
    TpExport = 5,
    Functions = 6
}
    